import { intl } from 'lang/intl'
import React, { type CSSProperties, useEffect } from 'react'

import { TtIcon } from '@23/ui-react'

import { type Notice, setNoticesShown, useNotices } from './Notices'

import './Notices.scss'

const NoticesBanner = () => {
  const notices = useNotices()

  useEffect(() => {
    setNoticesShown()
  }, [])

  const handleClick = (notice: Notice) => {
    notice.cta?.onClick?.(notice)
    if (notice.cta?.dismissOnClick) notice.close()
  }

  const noticeQueueSize = notices.queued.length
  return (
    <div className="notices-list">
      {noticeQueueSize > 0 && (
        <div className="excess-notice-count">
          {noticeQueueSize === 1
            ? intl.formatMessage({ defaultMessage: '1 more notice' })
            : intl.formatMessage(
                { defaultMessage: '{count} more notices' },
                { count: noticeQueueSize }
              )}
        </div>
      )}
      {notices.showing.map((n, idx, arr) => (
        <div
          key={n.id}
          className="notice-item"
          role="alert"
          style={
            {
              '--idx': arr.length - idx + (noticeQueueSize > 0 ? 1 : 0) - 1,
            } as CSSProperties
          }
        >
          <div className="notice-item-header">
            <div className="notice-item-message">{n.message}</div>
            {n.cta && (
              <>
                {n.cta.link ? (
                  <a
                    className="notice-item-cta-anchor"
                    href={n.cta.link}
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => {
                      // @ts-expect-error — TODO: fix
                      handleClick(n)
                      if (n.cta?.dismissOnClick) n.close()
                    }}
                  >
                    {n.cta.label}
                    <TtIcon library="one" name="external-link" />
                  </a>
                ) : (
                  <button
                    className="notice-item-cta-button"
                    type="button"
                    onClick={() => {
                      // @ts-expect-error — TODO: fix
                      handleClick(n)
                      if (n.cta?.dismissOnClick) n.close()
                    }}
                  >
                    {n.cta.label}
                  </button>
                )}
              </>
            )}
            {n.isClosable && (
              <>
                <div className="notice-item-separator" />
                <button
                  type="button"
                  className="notice-item-close"
                  onClick={n.close}
                >
                  <TtIcon name="close" library="one" />
                </button>
              </>
            )}
          </div>
          <div className="notice-item-content">{n.content}</div>
        </div>
      ))}
    </div>
  )
}

export { NoticesBanner }
